<template>
    <div>
      <v-idle @idle="onidle" @remind="onremind" :loop="true" :reminders="[10, 15]" :wait="5" :duration="300" />
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">Manufacture</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Manufacture</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="manufacture.id === null">New</span>
                  <span v-else>
                    {{ manufacture.manufacture_no }}
                  </span>
                </li>
              </ol>
              <span v-if="productListLength > 0">
                <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="actionForm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="manufacture.manufacture_no !== null">Action</button>
                <div class="dropdown-menu" aria-labelledby="actionForm">
                  <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
                  <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestVoid" data-backdrop="static" data-keyboard="false">Request Delete</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="refreshProductList">Product List</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="setJournal('reply')">Set Journal</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="setCOGS('reply')">Set COGS Product</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="setCOGSMaterial('reply')">Set COGS Material</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="setCOGSAll('reply')">Set COGS All</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="syncInventory('reply')">Sync Inventory</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="recalculateAll">Recalculate All</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="print">Print</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="updateMaterial">Update Material</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="updateProduct">Update Product</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="validateMaterialGroup">Validate Material</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="validateMaterialDuplicate">Validate Duplicate Material</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="validateAdditionalDuplicate">Validate Duplicate Additional</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="validateNonBiaya">Validate Film</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="deleteManufacture" v-if="authUser.permissions.manufacture_unlock">Delete</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="unlockManufacture" v-if="authUser.permissions.manufacture_unlock">Unlock</a>
                  <!-- <a class="dropdown-item" href="javascript:void(0)" v-show="manufacture.manufacture_no !== null" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false"><i class="fa fa-reply" aria-hidden="true"></i> Request Edit</button> -->
                  <!-- <button type="button" @click="setJournal('reply')" class="btn btn-sm btn-soft-outline-primary pull-left" v-if="manufacture.manufacture_no !== null">Set Journal</button>
                  <button type="button" @click="setCOGS('reply')" class="btn btn-sm btn-soft-outline-primary pull-left" v-if="manufacture.manufacture_no !== null">Set COGS Product</button>
                  <button type="button" @click="setCOGSMaterial('reply')" class="btn btn-sm btn-soft-outline-primary pull-left" v-if="manufacture.manufacture_no !== null">Set COGS Material</button>
                  <button type="button" @click="setCOGSAll('reply')" class="btn btn-sm btn-soft-outline-primary pull-left" v-if="manufacture.manufacture_no !== null">Set COGS All</button>
                  <button type="button" @click="syncInventory('reply')" class="btn btn-sm btn-soft-outline-primary pull-left" v-if="manufacture.manufacture_no !== null">Set Inventory</button>
                  <button type="button" @click="recalculateAll" class="btn btn-sm btn-soft-outline-primary pull-left" v-if="manufacture.manufacture_no !== null">Recalculate All</button>
                  <button type="button" @click="print" class="btn btn-sm btn-info pull-left" v-if="manufacture.manufacture_no !== null"><i class="fa fa-print"></i> Print</button>
                  <button type="button" class="btn btn-sm btn-warning pull-right" v-show="manufacture.manufacture_no !== null" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false"><i class="fa fa-reply" aria-hidden="true"></i> Request Edit</button> -->
                </div>
                <button type="button" @click="updateAll" class="btn btn-sm btn-soft-primary pull-left" v-show="manufacture.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
                <!-- <button type="button" @click="updateMaterial" class="btn btn-sm btn-soft-primary pull-left" v-show="manufacture.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update Material</button> -->
                <!-- <button type="button" @click="updateProduct" class="btn btn-sm btn-soft-primary pull-left" v-show="manufacture.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update Product</button> -->
                <button type="button" @click="createManufacture" class="btn btn-sm btn-soft-primary pull-left" v-show="manufacture.id == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
                <button type="button" @click="finishManufacture" class="btn btn-sm btn-soft-outline-primary pull-left" v-if="manufacture.manufacture_no !== null">Finish</button>
                <!-- <button type="button" @click="validateMaterialGroup" class="btn btn-sm btn-soft-outline-primary pull-left">Validate</button> -->
                <!-- <button type="button" @click="validateMaterialDuplicate" class="btn btn-sm btn-soft-outline-primary pull-left">Validate Duplicate Material</button> -->
                <!-- <button type="button" @click="validateAdditionalDuplicate" class="btn btn-sm btn-soft-outline-primary pull-left">Validate Duplicate Additional</button> -->
              </span>
              <span v-else>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-list">
            <div class="card-header">
              <div class="col-md-12">
                <h5 class="text-primary">
                  <span v-if="manufacture.id === null">New</span>
                  <span v-else>{{ manufacture.manufacture_no }}</span>
                  <span class="badge badge-primary ml-1">{{ manufacture.status }}</span>
                </h5>
              </div>
            </div>
            <div class="card-body">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a"></li>
                </ul>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <dl class="row dl-custom font-12">
                    <dt class="col-md-4">Order No.</dt>
                    <dd class="col-md-8">
                      <span v-if="manufacture.lock">{{ manufacture.order_no }}</span>
                      <input v-else type="text" class="form-control form-control-lite" v-model="manufacture.order_no"/>
                    </dd>

                    <dt class="col-md-4">Type</dt>
                    <dd class="col-md-8">
                      <select v-model="manufacture.type_id" class="form-control form-control-lite" :disabled="manufacture.lock">
                        <option v-for="t in manufactureTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                      </select>
                    </dd>

                    <!-- <dt class="col-md-4">PIC</dt>
                    <dd class="col-md-8"><v-select :options="employeeSelect" :reduce="employee => employee.meta.code" label="employee" v-model="manufacture.person_in_charge" class="vsc-custom"/></dd> -->

                    <dt class="col-md-4">Company</dt>
                    <dd class="col-md-8">
                      <select v-model="manufacture.company_no" class="form-control form-control-lite" :disabled="manufacture.id !== null">
                        <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                      </select>
                    </dd>

                    <dt class="col-md-4">Notes</dt>
                    <dd class="col-md-8"><textarea v-model="manufacture.notes" class="form-control form-control-lite" :disabled="manufacture.lock" ></textarea></dd>
                  </dl>
                </div>
                <div class="col-md-4">
                  <dl class="row dl-custom font-12">
                    <dt class="col-md-4">Manufacture Date</dt>
                    <dd class="col-md-8">
                      <datetime v-model="manufacture.manufacture_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" :disabled="manufacture.id !== null" v-if="authUser.permissions.sale_backdate"></datetime>
                      <datetime v-model="manufacture.manufacture_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" :disabled="manufacture.id !== null" v-else @input="checkDate"></datetime>
                    </dd>

                    <!-- <dt class="col-md-4">Start Date</dt>
                    <dd class="col-md-8"><datetime v-model="manufacture.manufacture_start_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" :disabled="manufacture.lock"></datetime></dd>

                    <dt class="col-md-4">Due Date</dt>
                    <dd class="col-md-8"><datetime v-model="manufacture.manufacture_due_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" :disabled="manufacture.lock"></datetime></dd> -->

                    <dt class="col-md-4">Finish date</dt>
                    <dd class="col-md-8"><datetime v-model="manufacture.manufacture_finish_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" :disabled="manufacture.lock"></datetime></dd>
                  </dl>
                </div>
                <div class="col-md-4">
                  <dl class="row dl-custom">
                    <dt class="col-md-4">Customer</dt>
                    <dd class="col-md-8">
                      <button v-if="manufacture.lock === false" type="button" data-toggle="modal" data-target="#modalCustomerList" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-hard-primary" @click="getCustomerList"><i class="fa fa-search"></i></button>
                      <button v-if="manufacture.lock === false" type="button" class="ml-2 btn btn-sm btn-soft-danger" @click="removeCustomer"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                    </dd>
                    <hr/>
                    <dt class="col-md-4">Customer No.</dt>
                    <dd class="col-md-8">
                      <span>{{ manufacture.customer_no }}</span>
                    </dd>
                    <dt class="col-md-4">Name</dt>
                    <dd class="col-md-8">{{ manufacture.customer.name }}</dd>
                    <dt class="col-md-4">Phone</dt>
                    <dd class="col-md-8">{{ manufacture.customer.phone }}</dd>
                    <dt class="col-md-4">Address</dt>
                    <dd class="col-md-8">{{ manufacture.customer.address }}</dd>
                    <hr>
                    <dt class="col-md-5" v-show="authUser.permissions.manufacture_cogs">Total Material & Additional</dt>
                    <dd class="col-md-7" v-show="authUser.permissions.manufacture_cogs"><b>{{ totalMaterialCOGSOrder + totalMaterialCOGSAdditional | currency }}</b></dd>
                    <dt class="col-md-5" v-show="authUser.permissions.manufacture_cogs">Total Product</dt>
                    <dd class="col-md-7" v-show="authUser.permissions.manufacture_cogs"><b>{{ totalMProduct | currency }}</b></dd>
                  </dl>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-12">
                  <ul class="nav nav-tabs nav-bordered">
                    <li class="nav-item">
                      <a href="#products" data-toggle="tab" aria-expanded="false" class="nav-link active">Products</a>
                    </li>
                    <li class="nav-item">
                      <a href="#material" data-toggle="tab" aria-expanded="false" class="nav-link">
                        Material
                        <span class="badge badge-success" v-if="totalCountMaterial > 0">{{ totalCountMaterial | currency }}</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#material-additional" data-toggle="tab" aria-expanded="false" class="nav-link">
                        Additional
                        <span class="badge badge-success" v-if="totalCountMaterialAdditional > 0">{{ totalCountMaterialAdditional | currency }}</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#material-non-cost" data-toggle="tab" aria-expanded="false" class="nav-link">Non Biaya</a>
                    </li>
                    <li class="nav-item">
                      <a href="#expense" data-toggle="tab" aria-expanded="false" class="nav-link">Expense</a>
                    </li>
                    <li class="nav-item">
                      <a href="#summary" data-toggle="tab" aria-expanded="false" class="nav-link">Summary</a>
                    </li>
                    <li class="nav-item">
                      <a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link" v-show="authUser.permissions.manufacture_journal">Journal</a>
                    </li>
                    <li class="nav-item">
                      <a href="#inventory" data-toggle="tab" aria-expanded="false" class="nav-link">Inventory</a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane active" id="products">
                      <div class="row">
                        <div class="col-md-12">
                          <span class="pull-right">
                            <button class="btn btn-sm btn-soft-primary" @click="calcMProduct" v-show="authUser.permissions.manufacture_cogs">Recalculate</button>
                          </span>
                          <div class="dynamic-table">
                            <table class="table table-sm table-hover table-item table-striped">
                              <thead>
                                <th>Product</th>
                                <th style="width: 10%">Qty</th>
                                <!-- <th style="width: 10%">Qty Finish</th> -->
                                <!-- <th style="width: 10%">Qty Retur</th> -->
                                <th style="width: 10%">UoM</th>
                                <th class="text-right" style="width: 10%" v-show="authUser.permissions.manufacture_cogs">Price</th>
                                <th class="text-right" style="width: 10%" v-show="authUser.permissions.manufacture_cogs">Total</th>
                                <th>#</th>
                              </thead>
                              <tbody>
                                <tr v-for="(p, index) in manufacture.mproducts" :key="p.id">
                                  <td>
                                    <span v-if="typeof p.id === 'undefined'">
                                      <v-select :options="getProductListStore" :reduce="product => product.meta.code" label="product" v-model="p.product_no" @input="setMProduct(index)" :disabled="manufacture.lock " />
                                    </span>
                                    <span v-else>
                                      <v-select :options="getProductListStore" :reduce="product => product.meta.code" label="product" v-model="p.product_no" @input="setMProduct(index)" disabled="disabled" />
                                    </span>
                                  </td>
                                  <td>
                                    <input type="text" class="form-control" v-model="p.qty_estimated" @keyup="calcRowProduct(index)" :disabled="manufacture.lock"/>
                                  </td>
                                  <!-- <td><input type="text" class="form-control" v-model="p.qty_finish" @keyup="calcRowProduct(index)"/></td> -->
                                  <!-- <td><input type="text" class="form-control" v-model="p.qty_return" @keyup="calcRowProduct(index)"/></td> -->
                                  <td>
                                    <select v-model="p.uom_id" class="form-control" disabled="disabled">
                                      <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                  </td>
                                  <td class="text-right" v-show="authUser.permissions.manufacture_cogs">
                                    {{ p.price | currency }}
                                    <!-- <input type="text" class="form-control" v-money="money2" v-model="p.price" @keyup="calcRowProduct(index)"/> -->
                                  </td>
                                  <td class="text-right" v-show="authUser.permissions.manufacture_cogs">{{ p.total | currency }}</td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-soft-outline-danger" :disabled="manufacture.lock" @click="removeProduct(index)"><i class="fa fa-trash"></i></button>
                                    <button type="button" class="btn btn-sm btn-soft-primary ml-1" :disabled="manufacture.lock" @click="getProductPackage(index)"><i class="fa fa-share"></i> Material</button>
                                    <button v-show="authUser.permissions.manufacture_cogs" type="button" class="btn btn-sm btn-soft-primary ml-1" @click="selectMProduct(index)"  data-toggle="modal" data-target="#modalManufactureMaterial" data-backdrop="static" data-keyboard="false">
                                      Set Price
                                    </button>
                                    <button type="button" class="btn btn-sm btn-soft-primary ml-1" @click="setAllMaterial(index)"  data-toggle="modal" data-target="#modalManufactureMaterial" data-backdrop="static" data-keyboard="false">
                                      Set All
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span v-if="manufacture.lock === false" @click="addProducts" class="link-secondary">+ Add Product</span>
                                    <span v-if="manufacture.lock === false" @click="addAllMaterial" class="link-secondary ml-5">All Material</span>
                                  </td>
                                  <td>
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td v-show="authUser.permissions.manufacture_cogs"></td>
                                  <td v-show="authUser.permissions.manufacture_cogs"></td>
                                  <td></td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td v-show="authUser.permissions.manufacture_cogs"></td>
                                  <td class="text-right" v-show="authUser.permissions.manufacture_cogs"><span class="font-14"><b>{{ totalMProduct | currency }}</b></span></td>
                                  <td></td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="material">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive">
                            <span class="pull-right">
                              <button v-show="authUser.permissions.manufacture_cogs" type="button" class="btn btn-sm btn-soft-primary" @click="getCogsAll">Recalculate</button>
                            </span>
                            <table class="table table-sm table-item table-hover table-striped">
                              <thead>
                                <th>Product</th>
                                <th>Material</th>
                                <th>Qty</th>
                                <th>Uom</th>
                                <th style="width: 10%" class="text-right" v-show="authUser.permissions.manufacture_cogs">COGS</th>
                                <th class="text-right" v-show="authUser.permissions.manufacture_cogs">Total</th>
                                <th>#</th>
                              </thead>
                              <tbody>
                                <tr v-for="(m, index) in materialOrder" :key="m.id">
                                  <td>
                                    <v-select :options="getProductListStore" :reduce="product => product.meta.code" label="product" v-model="m.mproduct_no" :disabled="manufacture.lock" />
                                  </td>
                                  <td>
                                    <v-select :options="getProductListCogs" :reduce="product => product.meta.code" label="product" v-model="m.product_no" @input="setProduct(index, m.category_id)" :disabled="manufacture.lock"/>
                                  </td>
                                  <td><input type="text" v-model="m.qty" class="form-control" @keyup="calcrow(index, m.category_id)" :disabled="manufacture.lock"/></td>
                                  <td>
                                    <select class="form-control" v-model="m.uom_id" disabled="disabled">
                                      <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                  </td>
                                  <td class="text-right" v-show="authUser.permissions.manufacture_cogs">{{ m.price | currency }}</td>
                                  <td class="text-right" v-show="authUser.permissions.manufacture_cogs">{{ m.total_cogs | currency }}</td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-soft-outline-danger" :disabled="manufacture.lock" @click="removeMaterial(index, m.category_id)"><i class="fa fa-trash"></i></button>
                                    <button v-show="authUser.permissions.manufacture_cogs" type="button" class="btn btn-sm btn-hard-primary" :disabled="manufacture.lock" @click="getCogsProduct(index, 'reply')"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <span v-if="manufacture.lock === false" @click="addMaterial('order')" class="link-secondary">+ Add Material</span>
                                  </td>
                                  <td class="text-right" v-show="authUser.permissions.manufacture_cogs"><b class="font-14">{{ totalMaterialCOGSOrder | currency }}</b></td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="material-additional">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive">
                            <span class="pull-right">
                              <button v-show="authUser.permissions.manufacture_cogs" class="btn btn-sm btn-soft-primary" @click="getCogsAdditionalAll">Recalculate</button>
                            </span>
                            <table class="table table-sm table-item table-striped">
                              <thead>
                                <th>Product</th>
                                <th>Material</th>
                                <th>Qty</th>
                                <th>Uom</th>
                                <th class="text-right" v-show="authUser.permissions.manufacture_cogs">COGS</th>
                                <th class="text-right" v-show="authUser.permissions.manufacture_cogs">Total</th>
                                <th></th>
                              </thead>
                              <tbody>
                                <tr v-for="(m, index) in materialAdditional" :key="m.id">
                                  <td>
                                    <v-select :options="getProductListStore" :reduce="product => product.meta.code" label="product" v-model="m.mproduct_no" :disabled="manufacture.lock" />
                                  </td>
                                  <td>
                                    <v-select :options="getProductListCogs" :reduce="product => product.meta.code" label="product" v-model="m.product_no" @input="setProduct(index, m.category_id)" :disabled="manufacture.lock"/>
                                  </td>
                                  <!-- <td>
                                    <select class="form-control" v-model="m.warehouse_no" :disabled="manufacture.lock">
                                      <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no">{{ w.warehouse_no }}</option>
                                    </select>
                                  </td> -->
                                  <td><input type="text" v-model="m.qty" class="form-control" @keyup="calcrow(index, m.category_id)" :disabled="manufacture.lock"/></td>
                                  <td>
                                    <select class="form-control" v-model="m.uom_id" disabled="disabled">
                                      <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                  </td>
                                  <td v-show="authUser.permissions.manufacture_cogs">{{ m.price | currency }}</td>
                                  <td class="text-right" v-show="authUser.permissions.manufacture_cogs">{{ m.total_cogs | currency }}</td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-soft-outline-danger" :disabled="manufacture.lock" @click="removeMaterial(index, m.category_id)"><i class="fa fa-trash"></i></button>
                                    <button type="button" class="btn btn-sm btn-hard-primary" :disabled="manufacture.lock" @click="getCogsProductAdditional(index, 'reply')"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <span v-if="manufacture.lock === false" @click="addMaterial('additional')" class="link-secondary">+ Add Additional</span>
                                  </td>
                                  <td class="text-right" v-show="authUser.permissions.manufacture_cogs"><b class="font-14">{{ totalMaterialCOGSAdditional | currency }}</b></td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="material-non-cost">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive">
                            <button data-toggle="modal" data-target="#modalGetOnHand" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-soft-primary btn-sm" @click="setIdDetail">
                              <i class="fa fa-search" aria-hidden="true"></i> Search
                            </button>
                            <button  class="btn btn-hard-primary btn-sm" @click="removeAllNonCost">
                              Remove
                            </button>
                            <table class="table table-sm table-item table-striped">
                              <thead>
                                <th>Hand No.</th>
                                <th>Product (on hand)</th>
                                <th>Date</th>
                                <th>Serial Number</th>
                                <th class="text-center">Ukuran Potong</th>
                                <th>Uom</th>
                                <th class="text-center">Qty</th>
                                <th>Uom</th>
                                <th>#</th>
                              </thead>
                              <tbody>
                                <tr v-for="(m, index) in materialNonCost" :key="m.id">
                                  <td>{{ m.hand_no }}</td>
                                  <td>
                                    <b>{{ m.product_no }}</b> {{ m.product }}
                                  </td>
                                  <td>{{ m.hand_date | dateFormat('DD/MM/YYYY') }}</td>
                                  <td><b>{{ m.hand_serial_number }}</b></td>
                                  <td class="text-center">{{ m.hand_qty }}</td>
                                  <td>{{ m.hand_uom_id }}</td>
                                  <td class="text-center">
                                    <!-- <input type="number" min="0" :max="m.limit" v-model="m.qty" class="form-control form-control-right" @keyup="calcrow(index, m.category_id)" :disabled="manufacture.lock"/> -->
                                    {{ m.qty }}
                                  </td>
                                  <td>
                                    {{ m.uom_id }}
                                    <!-- <select class="form-control" v-model="m.uom_id" disabled>
                                      <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select> -->
                                  </td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-soft-outline-danger" :disabled="manufacture.lock" @click="removeMaterial(index, m.category_id)"><i class="fa fa-trash"></i></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="6" class="text-right">Film yang dibutuhkan:</td>
                                  <td class="text-right">
                                    <b class="font-14 text-success">{{ totalFiberStack }}</b></td>
                                  <td></td>
                                  <td></td>
                                </tr>
                                <tr>
                                  <td colspan="6" class="text-right">Total:</td>
                                  <td class="text-right">
                                    <b class="font-14 text-danger" v-if="totalMaterialNonCost !== totalFiberStack">{{ totalMaterialNonCost | currency }}</b>
                                    <b class="font-14 text-success" v-else>{{ totalMaterialNonCost | currency }}</b>
                                  </td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="expense">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-reponsive">
                            <table class="table table-item table-sm table-hover table-striped">
                              <thead>
                                <th>Type</th>
                                <th>Notes</th>
                                <th class="text-right">Amount</th>
                                <th>#</th>
                              </thead>
                              <tbody>
                                <tr v-for="(e, index) in manufacture.expenses" :key="index">
                                  <td>
                                    <select v-model="e.type_id" class="form-control" :disabled="manufacture.lock">
                                      <option v-for="e in manufactureExpenseTypeList" :key="e.id" :value="e.id">{{ e.name }}</option>
                                    </select>
                                  </td>
                                  <td><input type="text" v-model="e.notes" class="form-control" :disabled="manufacture.lock"/></td>
                                  <td><input type="text" v-model="e.amount" v-money="money" class="form-control form-control-right" :disabled="manufacture.lock"/></td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-soft-outline-danger" :disabled="manufacture.lock" @click="removeExpense(index)"><i class="fa fa-trash"></i></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="2">
                                    <span v-if="manufacture.lock === false" @click="addExpense" class="link-secondary">+ Add Expense</span>
                                  </td>
                                  <td class="text-right"><span class="font-14"><b>{{ totalExpense | currency }}</b></span></td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="summary">
                      <div class="table-responsive">
                        <h5>Material:</h5>
                        <table class="table table-sm table-item table-striped">
                          <thead>
                            <th>Product No</th>
                            <th class="text-center">Qty</th>
                            <th class="text-center">Uom</th>
                            <th class="text-right" v-show="authUser.permissions.manufacture_cogs">Price</th>
                            <th class="text-right" v-show="authUser.permissions.manufacture_cogs">Total</th>
                          </thead>
                          <tbody>
                            <tr v-for="s in summaryMaterial" :key="s.id">
                              <td><b>[{{ s.product_no }}]</b> {{ s.product }}</td>
                              <td class="text-center">{{ s.qty }}</td>
                              <td class="text-center">{{ s.uom_id }}</td>
                              <td class="text-right" v-show="authUser.permissions.manufacture_cogs">{{ s.price | currency }}</td>
                              <td class="text-right" v-show="authUser.permissions.manufacture_cogs">{{ s.total | currency }}</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td v-show="authUser.permissions.manufacture_cogs" class="text-right">{{ totalSummaryMaterial | currency }}</td>
                            </tr>
                          </tfoot>
                        </table>
                        <h5>Film:</h5>
                        <table class="table table-sm table-item table-striped">
                          <thead>
                            <th>Hand No.</th>
                            <th>Date</th>
                            <th class="text-center">Ukuran Potong</th>
                            <th>Product</th>
                            <th class="text-center">Qty</th>
                            <th class="text-center">Uom</th>
                          </thead>
                          <tbody>
                            <tr v-for="s in summaryMaterialNonCost" :key="s.id">
                              <td>{{ s.hand_no }}</td>
                              <td>{{ s.hand_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td class="text-center">{{ s.hand_qty }} {{ s.hand_uom_id }}</td>
                              <td><b>[{{ s.product_no }}]</b> {{ s.product }}</td>
                              <td class="text-center">{{ s.qty }}</td>
                              <td class="text-center">{{ s.uom_id }}</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div class="tab-pane" id="journal" v-show="authUser.permissions.manufacture_journal">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsve">
                            <table class="table table-sm table-item table-hover table-striped">
                              <thead>
                                <th>Journal Code</th>
                                <th>Date</th>
                                <th>Account Code</th>
                                <th>Remark</th>
                                <th class="text-right">Debit</th>
                                <th class="text-right">Credit</th>
                              </thead>
                              <tbody>
                                <tr v-for="j in manufacture.journals" :key="j.id">
                                  <td>
                                    <span v-if="j.level === 1">
                                      <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                      <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                      <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                                    </span>
                                    <span v-else></span>
                                  </td>
                                  <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                  <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                                  <td>{{ j.remark }}</td>
                                  <td class="text-right">
                                    <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                                    <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                                    <span v-else></span>
                                  </td>
                                  <td class="text-right">
                                    <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                                    <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                                    <span v-else></span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <button type="button" class="btn btn-sm btn-hard-primary float-right" @click="postJournal"><i class="fa fa-plane"></i> Post Journal</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="inventory">
                      <div class="table-responsive">
                        <table class="table table-item table-sm table-hover table-striped">
                          <thead>
                            <th>Inventory No.</th>
                            <th>Date</th>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Uom</th>
                            <th v-show="authUser.permissions.manufacture_cogs">Price (COGS)</th>
                            <th v-show="authUser.permissions.manufacture_cogs">Total</th>
                            <th>COGS?</th>
                          </thead>
                          <tbody>
                            <tr v-for="i in manufacture.inventories" :key="i.id">
                              <td>{{ i.inventory_no }} </td>
                              <td>{{ i.inventory_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>[{{ i.product_no }}] {{ i.product }}</td>
                              <td>{{ i.qty_done }}</td>
                              <td>{{ i.uom_id }}</td>
                              <td v-show="authUser.permissions.manufacture_cogs">{{ i.cost | currency }}</td>
                              <td>{{ i.qty_done * i.cost | currency }}</td>
                              <td><span v-if="i.is_cost === true" style="color: green"><i class="fa fa-check"></i></span></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <!-- <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <dl class="row dl-custom font-14">
                    <dd class="col-md-4">Total Qty</dd>
                    <dt class="col-md-8 text-right">{{ totalQtyProduct | currency }} {{ mproduct.uom_id }}</dt>
                    <dd class="col-md-4">Total Material</dd>
                    <dt class="col-md-8 text-right">{{ totalMaterialCOGSOrder | currency }}</dt>
                    <dd class="col-md-4">Total Material Additional</dd>
                    <dt class="col-md-8 text-right">{{ totalMaterialCOGSAdditional | currency }}</dt>

                    <dd class="col-md-4">Total Expense</dd>
                    <dt class="col-md-8 text-right">{{ totalExpense | currency }}</dt>
                    <hr/>
                    <dd class="col-md-4">Biaya Produksi</dd>
                    <dt class="col-md-8 text-right">{{ totalMaterialCOGS + totalExpense | currency }}</dt>

                    <dd class="col-md-4">HPP</dd>
                    <dt class="col-md-8 text-right">{{ priceProductNet | currency }}</dt>
                  </dl>
                </div>
              </div> -->
            </div>
            <div class="card-footer">
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in manufacture.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <!-- <pre>{{ materialNonCost }}</pre> -->
        </div>
        <div class="col-md-4">
          <!-- <pre>{{ dataCollectMaterial }}</pre> -->
        </div>
        <div class="col-md-4">
          <!-- <pre>{{ productListSelect }}</pre> -->
          <!-- <pre>{{ productListSelect }}</pre> -->
          <!-- <pre>{{ dataCollect }}</pre> -->
        </div>
      </div>
      <ManufactureMaterialModal :material="materialProduct" :mproductLength="mproductLength" :materialAdditional="materialAdditionalCoef" :mproduct="manufactureProduct" @setPriceProduct="setPriceProduct"/>
      <SalesRequestModal @getRequestEdit="requestEdit" @getRequestVoid="requestVoid"/>
      <CustomerListModal @selectCustomerList="selectCustomerList" />
      <InventoryOnHandModal @selectOnHand="selectOH"/>
    </div>
</template>

<script>
import Axios from 'axios'
import { mapState } from 'vuex'
import { lockUrl, manufactureUrl, getHeader, productUrl, salesUrl, manufacture2Url } from '../../config'
import ManufactureMaterialModal from '@/components/manufacture/ManufactureMaterialModal.vue'
import CustomerListModal from '@/components/customer/CustomerListModal.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'
import InventoryOnHandModal from '@/components/inventory/InventoryOnHandModal.vue'

export default {
  name: 'ManufactureForm',
  props: ['manufacture', 'materialColl'],
  components: {
    ManufactureMaterialModal,
    Loading,
    SalesRequestModal,
    CustomerListModal,
    InventoryOnHandModal
  },
  data () {
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      alert: [],
      mproductLength: 0,
      ref: null,
      refNo: null,
      idDetail: null,
      detail: null,
      materialIndex: null,
      materialProduct: [],
      materialAdditionalCoef: [],
      manufactureProduct: {},
      mproductIndex: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 1,
        masked: true /* doesn't work with directive */
      }
    }
  },
  created () {
    this.ref = this.$route.query.ref
    this.refNo = this.$route.query.refNo
  },
  computed: {
    ...mapState({
      brachList: state => state.branches.branchList,
      vendorList: state => state.vendors.vendorList,
      productList: state => state.products.productListAll,
      taxList: state => state.taxes.taxList,
      uomList: state => state.uom.uomList,
      warehouseList: state => state.warehouses.warehouseList,
      employeeList: state => state.employees.employeeList,
      productListSelect: state => state.products.productListSelect,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser,
      manufactureTypeList: state => state.manufactures.manufactureTypeList,
      manufactureMaterialCategoryList: state => state.manufactures.manufactureMaterialCategoryList,
      manufactureExpenseTypeList: state => state.manufactures.manufactureExpenseTypeList,
      onHandProductList: state => state.inventories.onHandProductList
    }),
    totalFiberStack () {
      const array = this.manufacture.mproducts
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty_estimated)
      }
      if (sum % 2 === 0) {
        sum += 2
      } else {
        sum += 1
      }
      return sum
    },
    productListLength () {
      var sum = 0
      var array = this.productListSelect.filter(d => d.id !== null)
      sum = array.length
      return sum
    },
    groupMaterial () {
      var result = []
      var material = this.manufacture.materials.filter(d => d.category_id !== 'non-cost')
      if (material.length > 0) {
        material.reduce(function (res, value) {
          var key = value.product_no
          var qty = parseFloat(value.qty)
          if (!res[key]) {
            res[key] = {
              product_no: key,
              qty: qty,
              uom_id: value.uom_id
            }
            result.push(res[key])
          } else {
            res[key].qty = parseFloat(res[key].qty) + qty
          }
          return res
        }, {})
      }
      return result
    },
    groupMaterialEdit () {
      var result = []
      if (this.materialColl.length > 0) {
        this.materialColl.reduce(function (res, value) {
          var key = value.product_no
          var qty = parseFloat(value.qty)
          if (!res[key]) {
            res[key] = {
              product_no: key,
              qty: qty,
              uom_id: value.uom_id
            }
            result.push(res[key])
          } else {
            res[key].qty = parseFloat(res[key].qty) + qty
          }
          return res
        }, {})
      }
      return result
    },
    totalCountMaterial () {
      var count = 0
      var array = this.materialOrder
      for (let i = 0; i < array.length; i++) {
        count += 1
      }
      return count
    },
    totalCountMaterialAdditional () {
      var count = 0
      var array = this.materialAdditional
      for (let i = 0; i < array.length; i++) {
        count += 1
      }
      return count
    },
    totalMProduct () {
      var sum = 0
      var array = this.manufacture.mproducts
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    summaryMproductMaterial () {
      var result = []
      var array = this.manufacture.mproducts
      for (let i = 0; i < array.length; i++) {
        var materials = this.manufacture.materials.filter(d => d.mproduct_no === array[i].product_no)
        var obj = {
          id: array[i].id,
          product_no: array[i].product_no,
          materials: materials
        }
        result.push(obj)
      }
      return result
    },
    totalSummaryMaterial () {
      var array = this.summaryMaterial
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    summaryMaterial () {
      var result = []
      var productList = this.productListSelect
      var material = this.manufacture.materials.filter(d => d.category_id !== 'non-cost')
      material.reduce(function (res, value) {
        var key = value.product_no
        if (!res[key]) {
          var pdlc = productList.find(d => d.product_no === value.product_no)
          res[key] = {
            product_no: value.product_no,
            product: pdlc ? pdlc.product_name : null,
            qty: parseFloat(value.qty),
            uom_id: value.uom_id,
            price: value.price,
            total: value.total_cogs
          }
          result.push(res[key])
        } else {
          res[key].qty = parseFloat(res[key].qty) + parseFloat(value.qty)
          res[key].price = parseFloat(value.price)
          res[key].total = parseFloat(res[key].total) + parseFloat(value.total_cogs)
        }
        return res
      }, {})
      return result
    },
    summaryMaterialNonCost () {
      var result = []
      var productList = this.productListSelect
      var material = this.manufacture.materials.filter(d => d.category_id === 'non-cost')
      material.reduce(function (res, value) {
        var key = value.product_no + value.hand_qty
        if (!res[key]) {
          var pdlc = productList.find(d => d.product_no === value.product_no)
          res[key] = {
            product_no: value.product_no,
            product: pdlc ? pdlc.product_name : null,
            hand_qty: value.hand_qty,
            hand_uom_id: value.hand_uom_id,
            hand_no: value.hand_no,
            hand_date: value.hand_date,
            qty: parseFloat(value.qty),
            uom_id: value.uom_id,
            price: value.price,
            total: value.total_cogs
          }
          result.push(res[key])
        } else {
          res[key].qty = parseFloat(res[key].qty) + parseFloat(value.qty)
          res[key].price = parseFloat(value.price)
          res[key].total = parseFloat(res[key].total) + parseFloat(value.total_cogs)
        }
        return res
      }, {})
      return result
    },
    onHandSelect () {
      var loop = []
      var array = this.onHandProductList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          onhand: '[' + array[i].qty_stock + ' ' + array[i].uom_stock + '] - ' + array[i].hand_date + ' [' + array[i].product_no + '] ' + array[i].product_description,
          meta: {
            code: array[i].id
          }
        }
        loop.push(obj)
      }
      return loop
    },
    materialOrder () {
      return this.manufacture.materials.filter(d => d.category_id === 'order')
    },
    materialAdditional () {
      return this.manufacture.materials.filter(d => d.category_id === 'additional')
    },
    materialNonCost () {
      return this.manufacture.materials.filter(d => d.category_id === 'non-cost')
    },
    totalQtyProduct () {
      var total = 0
      if (this.mproduct.qty_finish === '0') {
        if (this.mproduct.qty_estimated === '0') {
          total = 0
        } else {
          total = parseFloat(this.mproduct.qty_estimated)
        }
      } else {
        total = parseFloat(this.mproduct.qty_finish)
      }
      return total
    },
    priceProductNet () {
      var totalBiaya = this.totalMaterialCOGS + this.totalExpense
      var total = totalBiaya / parseFloat(this.totalQtyProduct)
      return Math.ceil(total)
    },
    totalExpense () {
      var sum = 0
      var array = this.manufacture.expenses
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].amount.replace(/\./g, ''))
      }
      return sum
    },
    getMaterialCategorySelect () {
      // var loop = []
      var array = this.manufactureMaterialCategoryList.filter(d => d.type_id === this.manufacture.type_id)
      return array
    },
    dataCollectExpense () {
      var data = []
      var array = this.manufacture.expenses
      for (let i = 0; i < array.length; i++) {
        if (array[i].amount !== '0') {
          var obj = {}
          if (typeof array[i].id === 'undefined') {
            obj = {
              manufacture_no: this.manufacture.manufacture_no,
              amount: array[i].amount.replace(/\./g, ''),
              notes: array[i].notes,
              type_id: array[i].type_id
            }
          } else {
            obj = {
              id: array[i].id,
              manufacture_no: this.manufacture.manufacture_no,
              amount: array[i].amount.replace(/\./g, ''),
              notes: array[i].notes,
              type_id: array[i].type_id
            }
          }
          data.push(obj)
        }
      }
      return data
    },
    dataCollectMaterial () {
      var data = []
      var array = this.manufacture.materials
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            manufacture_no: this.manufacture.manufacture_no,
            product_no: array[i].product_no,
            qty: array[i].qty,
            uom_id: array[i].uom_id,
            price: array[i].price,
            total_cogs: array[i].total_cogs,
            warehouse_no: array[i].warehouse_no,
            receive: array[i].receive,
            received_by: array[i].received_by,
            receive_date: array[i].receive_date,
            manufacture_date: this.manufacture.manufacture_date,
            company_no: this.manufacture.company_no,
            branch_no: this.manufacture.branch_no,
            category_id: array[i].category_id,
            type_id: array[i].type_id,
            hand_id: array[i].hand_id,
            hand_qty: array[i].hand_qty,
            hand_uom_id: array[i].hand_uom_id,
            mproduct_no: array[i].mproduct_no
          }
        } else {
          obj = {
            id: array[i].id,
            manufacture_no: this.manufacture.manufacture_no,
            product_no: array[i].product_no,
            qty: array[i].qty,
            uom_id: array[i].uom_id,
            price: array[i].price,
            total_cogs: array[i].total_cogs,
            warehouse_no: array[i].warehouse_no,
            receive: array[i].receive,
            received_by: array[i].received_by,
            receive_date: array[i].receive_date,
            manufacture_date: this.manufacture.manufacture_date,
            company_no: this.manufacture.company_no,
            branch_no: this.manufacture.branch_no,
            category_id: array[i].category_id,
            type_id: array[i].type_id,
            hand_id: array[i].hand_id,
            hand_qty: array[i].hand_qty,
            hand_uom_id: array[i].hand_uom_id,
            mproduct_no: array[i].mproduct_no
          }
        }
        data.push(obj)
      }
      return data
    },
    dataCollect () {
      var mpro = []
      var arrMpro = this.manufacture.mproducts
      for (let i = 0; i < arrMpro.length; i++) {
        var obj = {}
        if (typeof arrMpro[i].id === 'undefined') {
          obj = {
            manufacture_no: arrMpro[i].manufacture_no,
            product_no: arrMpro[i].product_no,
            qty_estimated: arrMpro[i].qty_estimated,
            qty_finish: arrMpro[i].qty_finish,
            qty_return: arrMpro[i].qty_return,
            uom_id: arrMpro[i].uom_id,
            notes: arrMpro[i].notes,
            price: arrMpro[i].price,
            total: arrMpro[i].total
          }
          mpro.push(obj)
        } else {
          obj = {
            id: arrMpro[i].id,
            manufacture_no: arrMpro[i].manufacture_no,
            product_no: arrMpro[i].product_no,
            qty_estimated: arrMpro[i].qty_estimated,
            qty_finish: arrMpro[i].qty_finish,
            qty_return: arrMpro[i].qty_return,
            uom_id: arrMpro[i].uom_id,
            notes: arrMpro[i].notes,
            price: arrMpro[i].price,
            total: arrMpro[i].total
          }
          mpro.push(obj)
        }
      }
      var mnfDate = new Date(this.manufacture.manufacture_date)
      const nowDate = new Date()
      const mewMnfDate = mnfDate.getFullYear() + '-' + (mnfDate.getMonth() + 1) + '-' + mnfDate.getDate() + ' ' + nowDate.getHours() + ':' + nowDate.getMinutes() + ':' + nowDate.getSeconds()
      var data = {
        id: this.manufacture.id,
        manufacture_no: this.manufacture.manufacture_no,
        manufacture_date: mewMnfDate,
        manufacture_start_date: this.manufacture.manufacture_start_date,
        manufacture_due_date: this.manufacture.manufacture_due_date,
        manufacture_finish_date: this.manufacture.manufacture_finish_date,
        notes: this.manufacture.notes,
        customer_no: this.manufacture.customer_no,
        person_in_charge: this.manufacture.person_in_charge,
        company_no: this.manufacture.company_no,
        branch_no: this.manufacture.branch_no,
        inventory_no: this.manufacture.inventory_no,
        status: this.manufacture.status,
        lock: this.manufacture.lock,
        type_id: this.manufacture.type_id,
        total_cost: this.totalMaterialCOGS,
        total_expense: this.manufacture.total_expense,
        order_no: this.manufacture.order_no,
        mproducts: mpro
      }
      return data
    },
    getProductListCogs () {
      var array = this.productListSelect.filter(d => d.type_id !== 5)
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product: '[' + array[i].product_no + '] ' + array[i].product_name,
          meta: {
            code: array[i].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getProductListStore () {
      var array = this.productListSelect.filter(p => p.type_id !== 1).filter(p => p.type_id !== 2).filter(p => p.type_id !== 5)
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product: '[' + array[i].product_no + '] ' + array[i].product_name,
          meta: {
            code: array[i].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getProductListType () {
      var array = this.productListSelect
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product: '[' + array[i].product_no + '] ' + array[i].product_name + ' ' + '(' + array[i].cost + ' ' + array[i].uom_id + ')',
          meta: {
            code: array[i].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    totalMaterialCOGS () {
      var sum = 0
      var array = this.manufacture.materials
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_cogs.toString().replace(/\./g, ''))
      }
      return sum
    },
    totalMaterialCOGSOrder () {
      var sum = 0
      var array = this.manufacture.materials.filter(d => d.category_id === 'order')
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_cogs.toString())
      }
      return sum
    },
    totalMaterialCOGSAdditional () {
      var sum = 0
      var array = this.manufacture.materials.filter(d => d.category_id === 'additional')
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_cogs)
      }
      return sum
    },
    totalMaterialNonCost () {
      var sum = 0
      var array = this.manufacture.materials.filter(d => d.category_id === 'non-cost')
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty.toString().replace(/\./g, ''))
      }
      return sum
    },
    mproduct () {
      return this.manufacture.mproducts[0]
    },
    employeeSelect () {
      var array = this.employeeList
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          employee: '[' + array[i].employee_no + '] ' + array[i].name,
          meta: {
            code: array[i].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    async unlockManufacture () {
      await Axios.post(manufactureUrl + '/unlock', { id: this.manufacture.id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          const data = response.data.data
          this.manufacture.lock = data.lock
          this.manufacture.status = data.status
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response.data.message)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    removeCustomer () {
      this.manufacture.customer_no = null
      this.manufacture.customer = {
        name: null,
        phone: null,
        address: null
      }
    },
    setIdDetail () {
      var pyd = {
        begin: null,
        end: null,
        company: this.manufacture.company_no,
        type: null
      }
      this.$store.dispatch('getInventoryOnHandList', pyd)
    },
    selectOH (value) {
      var warehouse = this.warehouseList.find(d => d.company_no === this.manufacture.company_no)
      var array = value.details
      for (let i = 0; i < array.length; i++) {
        if (array[i].c_type === 'in' || array[i].c_type === 'convert-in') {
          var obj = {
            manufacture_no: this.manufacture_no,
            product_no: array[i].product_no,
            product: array[i].product_description,
            qty: array[i].qty,
            uom_id: array[i].uom_id,
            price: '0',
            total_cogs: '0',
            warehouse_no: warehouse ? warehouse.warehouse_no : null,
            receive: null,
            received_by: null,
            receive_date: null,
            company_no: this.manufacture.company_no,
            branch_no: this.authUser.branch_no,
            manufacture_date: this.manufacture.manufacture_date,
            category_id: 'non-cost',
            type_id: this.manufacture.type_id,
            hand_id: array[i].id,
            hand_qty: array[i].qty_stock,
            hand_uom_id: array[i].uom_stock,
            hand_date: array[i].hand_date,
            hand_no: array[i].hand_no,
            hand_serial_number: array[i].serial_number,
            mproduct_no: null
          }
          this.manufacture.materials.push(obj)
        }
      }
    },
    onidle: function () {
      console.log('trigger logout')
      this.backParent()
    },
    onremind: function (time) {
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.manufacture.manufacture_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = remaining / (1000 * 3600 * 24)
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 2) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.manufacture.manufacture_date = date1.toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.manufacture.manufacture_date = date1.toISOString()
      }
    },
    async validateMaterialDuplicate () {
      var array = this.manufacture.materials.filter(d => d.category_id === 'order')
      var result = []
      var resultProductNo = []
      array.reduce(function (res, value) {
        // Check product_no null & duplicate
        if (value.product_no !== null) {
          var key = value.product_no + value.mproduct_no
          if (!res[key]) {
            res[key] = {
              product_no: value.product_no
            }
          } else {
            result.push({
              product_no: value.product_no
            })
          }
        } else {
          resultProductNo.push({
            product_no: value.product_no
          })
        }
        return res
      }, {})

      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          this.alert.push('Duplicate Product Material (' + result[i].product_no + ')')
        }
      }
    },
    async validateAdditionalDuplicate () {
      var array = this.manufacture.materials.filter(d => d.category_id === 'additional')
      var result = []
      var resultProductNo = []
      array.reduce(function (res, value) {
        // Check product_no null & duplicate
        if (value.product_no !== null) {
          var key = value.product_no
          if (!res[key]) {
            res[key] = {
              product_no: value.product_no
            }
          } else {
            result.push({
              product_no: value.product_no
            })
          }
        } else {
          resultProductNo.push({
            product_no: value.product_no
          })
        }
        return res
      }, {})

      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          this.alert.push('Duplicate Product Additional (' + result[i].product_no + ')')
        }
      }
    },
    async validateNonBiaya () {
      const type = this.manufactureTypeList.find(d => d.id === this.manufacture.type_id)
      if (type.name === 'Produksi Fiber') {
        // if (this.materialNonCost.length <= 0) {
        //   this.alert.push('<strong>Film</strong> belum di input ')
        // }
        // if (this.totalFiberStack !== this.totalMaterialNonCost) {
        //   this.alert.push('<strong>Fim</strong>, jumlah tidak sesuai dengan kebutuhan!!')
        // }
      }
    },
    async refreshProductList () {
      this.$store.commit('SET_PRODUCT_LIST_COGS', [])
      await console.log('first init: ' + this.productListSelect.length)
      var payload = {
        date: this.manufacture.manufacture_date
      }
      await this.$store.dispatch('getProductListCogs', payload)
    },
    async deleteManufacture () {
      var msg = null
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$Progress.start()
          this.loader.isLoading = true
          Axios.delete(manufactureUrl + '/' + this.manufacture.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              msg = response.data.message
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$Progress.finish()
              this.loader.isLoading = false
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Process Kartu Stock', 'success')
      await this.setCOGSAll('no reply')
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', msg, 'success')
      await this.backParent()
    },
    selectCustomerList (value) {
      this.manufacture.customer_no = value.customer_no
      this.manufacture.customer = value
    },
    getCustomerList: function () {
      this.$store.dispatch('getCustomerListLite')
      // this.$store.dispatch('getCustomerList')
    },
    async updateAll () {
      if (this.manufacture.counter > 2 && this.authUser.username !== 'root') {
        this.$swal('Error', 'Data telah diupdate lebih dari dua kali', 'error')
      }
      this.alert = []
      await this.validateMaterialDuplicate()
      await this.validateAdditionalDuplicate()
      await this.validateMaterialGroup()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data Material tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      // START MATERIAL
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.updateManufacture()
      await this.$Progress.finish()
      this.loader.isLoading = false
      this.$emit('backClickID', this.manufacture.id)
      await this.$swal('Success', 'Update Material  Kartu Stock', 'success')
      await this.setCOGSMaterial('no reply')
      // Start Update Product
      await this.validateMaterialGroup()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data Material tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.recalculateAll()
      await this.updateManufacture()
      await this.$swal('Success', 'Update Product Kartu Stock', 'success')
      await this.syncInventory('no reply')
      await this.setCOGSAll('no reply')
      await this.setJournal('no reply')
      await this.$Progress.finish()
      this.loader.isLoading = false
      this.alert = []
    },
    async updateMaterial () {
      if (this.manufacture.counter > 2 && this.authUser.username !== 'root') {
        this.$swal('Error', 'Data telah diupdate lebih dari dua kali', 'error')
      }
      this.alert = []
      await this.validateMaterialDuplicate()
      await this.validateAdditionalDuplicate()
      await this.validateMaterialGroup()
      await this.validateNonBiaya()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data Material tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.updateManufacture()
      await this.setCOGSMaterial('no reply')
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success update material', 'success')
      this.alert = []
    },
    async updateProduct () {
      if (this.manufacture.counter > 2 && this.authUser.username !== 'root') {
        await this.$swal('Error', 'Data telah diupdate lebih dari dua kali', 'error')
      }
      await this.validateMaterialGroup()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data Material tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.recalculateAll()
      await this.updateManufacture()
      await this.syncInventory('no reply')
      await this.setCOGSAll('no reply')
      await this.setJournal('no reply')
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success update product manufacture', 'success')
      this.alert = []
    },
    async recalculateAll () {
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.getCogsAll()
      await this.getCogsAdditionalAll()
      await this.calcMProduct()
      await this.$Progress.finish()
      this.loader.isLoading = false
      this.alert = []
    },
    async requestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.manufacture.manufacture_no,
        lock_note: value,
        type: 'manufacture'
      }
      console.log(obj)
      await Axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Lock',
            'Manufacture has been requested',
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    async requestVoid (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.manufacture.manufacture_no,
        lock_note: value,
        type: 'manufacture-void'
      }
      console.log(obj)
      await Axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Lock',
            'Manufacture has been requested',
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    async calcMProduct () {
      var array = this.manufacture.mproducts
      var mproductLength = 0
      for (let a = 0; a < array.length; a++) {
        mproductLength += parseFloat(array[a].qty_estimated)
      }
      for (let i = 0; i < array.length; i++) {
        var mproduct = array[i].product_no
        var arr = this.manufacture.materials.filter(d => d.mproduct_no === mproduct).filter(d => d.category_id !== 'non-cost')
        var sumMaterial = 0
        for (let a = 0; a < arr.length; a++) {
          sumMaterial += parseFloat(arr[a].total_cogs)
        }
        var arr2 = this.manufacture.materials.filter(d => d.mproduct_no === null)
        for (let a = 0; a < arr2.length; a++) {
          var price2 = parseFloat(arr2[a].total_cogs) / mproductLength
          console.log(arr2[a].product_no + ': ' + arr2[a].total_cogs + ' ' + price2 + '(' + mproductLength + ')')
          sumMaterial += price2 * parseFloat(array[i].qty_estimated)
        }
        var price = sumMaterial / parseFloat(array[i].qty_estimated)
        var total = sumMaterial
        array[i].price = price
        array[i].total = total
      }
    },
    async getCogsAll () {
      var array = this.materialOrder
      for (let i = 0; i < array.length; i++) {
        await this.getCogsProduct(i, 'no reply')
      }
    },
    async getCogsProduct (index, reply) {
      var detail = this.materialOrder[index]
      var data = {
        ref_no: this.manufacture.manufacture_no,
        notes: detail.mproduct_no + '#order',
        product_no: detail.product_no
      }
      console.log(data)
      console.log(productUrl + '/cost/product-by-ref-no')
      await Axios.post(productUrl + '/cost/product-by-ref-no', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          const cost = response.data.data
          console.log(cost + ' / ' + detail.qty)
          var price = cost / detail.qty
          console.log(price)
          detail.price = price.toString()
          detail.total_cogs = cost.toString()
          if (reply === 'reply') {
            this.$swal('Success', response.data.message, 'success')
          }
          // detail.price = cost / detail.qty
          // detail.total_cogs = cost
          // var cost = Math.round(product.cost)
          // cost = cost.toString()
          // var totalCost = parseFloat(detail.qty) * parseFloat(cost)

          // detail.product_no = product.product_no
          // detail.product = product.product_name
          // detail.uom_id = product.uom_id
          // detail.price = cost
          // detail.total_cogs = Math.round(totalCost)
          // detail.receive = null
          // detail.received_by = null
          // detail.receive_date = null
          // detail.company_no = this.manufacture.company_no
          // detail.branch_no = this.manufacture.branch_no
          // detail.manufacture_date = this.manufacture.manufacture_date
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getCogsAdditionalAll () {
      var array = this.materialAdditional
      for (let i = 0; i < array.length; i++) {
        await this.getCogsProductAdditional(i, 'no reply')
      }
    },
    async getCogsProductAdditional (index, reply) {
      var detail = this.materialAdditional[index]
      var data = {
        ref_no: this.manufacture.manufacture_no,
        notes: detail.mproduct_no === null ? '#additional' : detail.mproduct_no + '#additional',
        product_no: detail.product_no
      }
      console.log('product-by-ref-no')
      console.log(data)
      await Axios.post(productUrl + '/cost/product-by-ref-no', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          const cost = response.data.data
          console.log(cost + ' / ' + detail.qty)
          var price = cost / detail.qty
          console.log(price)
          detail.price = price.toString()
          detail.total_cogs = cost.toString()
          if (reply === 'reply') {
            this.$swal('Success', response.data.message, 'success')
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async setAllMaterial (index) {
      await this.getProductPackage(index)
      await this.selectMProduct(index)
    },
    async postJournal () {
      var array = this.manufacture.journals.filter(d => d.level === 1)
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          id: array[i].id
        }
        loop.push(obj)
      }
      this.dataPostJournal = {
        journal: loop
      }
      console.log(this.dataPostJournal)
      console.log(salesUrl + '/journal/post-collection')
      await Axios.post(salesUrl + '/journal/post-collection', this.dataPostJournal, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClickID', this.manufacture.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            error
          )
        })
    },
    async setJournal (reply) {
      var array = this.manufacture.mproducts
      for (let i = 0; i < array.length; i++) {
        await Axios.post(manufactureUrl + '/mproduct/journal', { id: array[i].id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      if (reply === 'reply') {
        await this.$swal('Success', 'Success set journal manufacture', 'success')
        await this.$emit('backClickID', this.manufacture.id)
      }
    },
    async addAllMaterial () {
      var array = this.manufacture.mproducts
      for (let i = 0; i < array.length; i++) {
        await this.getProductPackage(i)
      }
    },
    selectMProduct (index) {
      this.mproductIndex = index
      var mproduct = this.manufacture.mproducts[index]
      this.materialProduct = this.manufacture.materials.filter(d => d.mproduct_no === mproduct.product_no)
      this.materialAdditionalCoef = this.manufacture.materials.filter(d => d.mproduct_no === null).filter(d => d.category_id === 'additional')
      this.manufactureProduct = mproduct
      this.mproductLength = 0
      var array = this.manufacture.mproducts
      for (let i = 0; i < array.length; i++) {
        this.mproductLength += parseFloat(array[i].qty_estimated)
      }
    },
    setPriceProduct (value) {
      console.log(value)
      var mproduct = this.manufacture.mproducts[this.mproductIndex]
      var cost = value
      mproduct.price = cost.toString()
      mproduct.total = cost * parseFloat(mproduct.qty_estimated)
    },
    setProductOnHand (index) {
      var material = this.materialNonCost[index]
      var onhand = this.onHandProductList.find(d => d.id === material.hand_id)
      material.product_no = onhand.product_no
      material.qty = onhand.qty
      material.uom_id = onhand.uom_id
      material.limit = onhand.qty
    },
    async getProductPackage (index) {
      var mpro = this.manufacture.mproducts[index]
      if (mpro.product_no === null) {
        this.$swal('Error', 'Pilih Product terlebih dahulu', 'error')
      }
      var arr = this.manufacture.materials.filter(d => d.product_no === null)
      for (let a = 0; a < arr.length; a++) {
        this.manufacture.materials.splice(a, 1)
      }
      var data = {
        product_no: mpro.product_no,
        date: this.manufacture.manufacture_date
      }
      var warehouse = this.warehouseList.find(d => d.company_no === this.manufacture.company_no)
      await Axios.post(productUrl + '/package/get-by-product-no', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var pkg = response.data.data
          if (pkg.length > 0) {
            console.log(pkg)
            for (let i = 0; i < pkg.length; i++) {
              var material = this.manufacture.materials.find(d => d.product_no === pkg[i].product_no && d.mproduct_no === mpro.product_no)
              if (material) {
              } else {
                var qty = parseFloat(pkg[i].qty) * parseFloat(mpro.qty_estimated)
                var total = qty * Math.round(parseFloat(pkg[i].cost))
                var obj = {
                  manufacture_no: this.manufacture.manufacture_no,
                  product_no: pkg[i].product_no,
                  product: pkg[i].product_name,
                  qty: Number.parseFloat(qty).toFixed(2),
                  uom_id: pkg[i].uom_id,
                  price: Math.round(parseFloat(pkg[i].cost)).toString(),
                  total_cogs: total.toString(),
                  warehouse_no: warehouse ? warehouse.warehouse_no : null,
                  receive: null,
                  received_by: null,
                  receive_date: null,
                  company_no: this.authUser.company_no,
                  branch_no: this.authUser.branch_no,
                  manufacture_date: this.manufacture.manufacture_date,
                  category_id: 'order',
                  hand_id: null,
                  hand_qty: null,
                  hand_uom_id: null,
                  mproduct_no: pkg[i].mproduct_no
                }
                console.log(obj)
                this.manufacture.materials.push(obj)
              }
            }
          } else {
            var obj2 = {
              manufacture_no: this.manufacture.manufacture_no,
              product_no: null,
              product: null,
              qty: 1,
              uom_id: null,
              price: '0',
              total_cogs: '0',
              warehouse_no: warehouse ? warehouse.warehouse_no : null,
              receive: null,
              received_by: null,
              receive_date: null,
              company_no: this.authUser.company_no,
              branch_no: this.authUser.branch_no,
              manufacture_date: this.manufacture.manufacture_date,
              category_id: 'order',
              hand_id: null,
              hand_qty: null,
              hand_uom_id: null,
              mproduct_no: mpro.product_no
            }
            this.manufacture.materials.push(obj2)
          }
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    removeProduct (index) {
      var mpro = this.manufacture.mproducts[index]
      if (typeof mpro.id === 'undefined') {
        this.manufacture.mproducts.splice(index, 1)
        var arr = this.manufacture.materials.filter(d => d.mproduct_no === mpro.product_no)
        for (let i = 0; i < arr.length; i++) {
          var idx = this.manufacture.materials.findIndex(d => d.mproduct_no === mpro.product_no && d.product_no === arr[i].product_no)
          this.manufacture.materials.splice(idx, 1)
        }
        var invdex = this.manufacture.inventories.findIndex(d => d.product_no === mpro.product_no)
        this.manufacture.inventories.splice(invdex, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(manufactureUrl + '/mproduct/' + mpro.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.message)
                var data = {
                  date: this.manufacture.manufacture_finish_date,
                  product_no: mpro.product_no,
                  type: 'all',
                  company_no: null
                }
                // sync cogs mproducts
                Axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                    this.$swal('Error')
                  })
                this.manufacture.mproducts.splice(index, 1)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
            var arr = this.manufacture.materials.filter(d => d.mproduct_no === mpro.product_no)
            for (let i = 0; i < arr.length; i++) {
              var idx = this.manufacture.materials.findIndex(d => d.mproduct_no === mpro.product_no && d.product_no === arr[i].product_no)
              this.manufacture.materials.splice(idx, 1)
            }
            var invIdx = this.manufacture.inventories.findIndex(d => d.product_no === mpro.product_no)
            this.manufacture.inventories.splice(invIdx, 1)
          }
        })
      }
    },
    calcRowProduct (index) {
      var mpro = this.manufacture.mproducts[index]
      var qtyFinish = parseFloat(mpro.qty_finish)
      var qtyEstimated = parseFloat(mpro.qty_estimated)
      var total = 0
      var price = parseFloat(mpro.price.replace(/\./g, ''))
      if (qtyFinish !== 0) {
        total = qtyFinish * price
      } else {
        total = qtyEstimated * price
      }
      mpro.total = total
    },
    addProducts () {
      var obj = {
        manufacture_no: null,
        product_no: null,
        qty_estimated: '1',
        qty_finish: '0',
        qty_return: '0',
        uom_id: null,
        notes: null,
        price: '0',
        total: '0'
      }
      this.manufacture.mproducts.push(obj)
    },
    addExpense () {
      var obj = {
        manufacture_no: this.manufacture.manufacture_no,
        amount: '0',
        notes: null
      }
      this.manufacture.expenses.push(obj)
    },
    removeExpense (index) {
      var expense = this.manufacture.expenses[index]
      if (typeof expense.id === 'undefined') {
        this.manufacture.expenses.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(manufactureUrl + '/expense/' + expense.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.manufacture.expenses.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    setMProduct (index) {
      var mpro = this.manufacture.mproducts[index]
      var product = this.productListSelect.find(d => d.product_no === mpro.product_no)
      mpro.product_no = product.product_no
      mpro.uom_id = product.uom_id
      mpro.price = product.cost
    },
    setProduct (index, category) {
      var detail = {}
      if (category === 'order') {
        detail = this.materialOrder[index]
      } else if (category === 'additional') {
        detail = this.materialAdditional[index]
      } else if (category === 'non-cost') {
        detail = this.materialNonCost[index]
      }
      var warehouse = this.warehouseList.find(d => d.company_no === this.manufacture.company_no)
      var product = this.productListSelect.find(d => d.product_no === detail.product_no)
      if (product) {
        // var qty = parseFloat(product.total_qty)
        // if (qty !== 0) {
        var cost = '0'
        if (category !== 'non-cost') {
          cost = Math.round(product.cost)
          cost = cost.toString()
        } else {
          cost = '0'
        }
        detail.manufacture_no = this.manufacture.manufacture_no
        detail.product_no = product.product_no
        detail.product = product.product_name
        detail.qty = '1'
        detail.uom_id = product.uom_id
        detail.price = cost
        detail.total_cogs = cost
        detail.warehouse_no = warehouse ? warehouse.warehouse_no : null
        detail.receive = null
        detail.received_by = null
        detail.receive_date = null
        detail.company_no = this.manufacture.company_no
        detail.branch_no = this.manufacture.branch_no
        detail.manufacture_date = this.manufacture.manufacture_date
        // } else {
        //   detail.manufacture_no = this.manufacture.manufacture_no
        //   detail.product_no = null
        //   detail.product = null
        //   detail.qty = '1'
        //   detail.uom_id = null
        //   detail.price = '0'
        //   detail.total_cogs = '0'
        //   detail.warehouse_no = warehouse ? warehouse.warehouse_no : null
        //   detail.receive = null
        //   detail.received_by = null
        //   detail.receive_date = null
        //   detail.company_no = this.manufacture.company_no
        //   detail.branch_no = this.manufacture.branch_no
        //   detail.manufacture_date = this.manufacture.manufacture_date
        // this.$swal('Error', 'Jumlah Stock tidak bisa kosong', 'error')
        // }
      }
    },
    calcrow (index, category) {
      var material = {}
      if (category === 'order') {
        material = this.materialOrder[index]
      } else if (category === 'additional') {
        material = this.materialAdditional[index]
      } else if (category === 'non-cost') {
        material = this.materialNonCost[index]
        if (material.qty > material.limit) {
          this.$swal('Error', 'Quantity over the limit', 'error')
          material.qty = material.limit
        }
      }
      var qty = material.qty === null || material.qty === '' ? 0 : parseFloat(material.qty)
      var total = qty * parseFloat(material.price)
      // console.log(parseFloat(material.qty) + ' * ' + parseFloat(material.price.replace(/\./g, '')) + ' = ' + total)
      material.total_cogs = Math.round(total).toString()
    },
    setMaterialIndex (index) {
      this.materialIndex = index
    },
    selectProduct (value) {
      var mat = this.manufacture.materials[this.materialIndex]
      mat.product_no = value.product_no
      mat.product = value.product_name
      mat.qty = 1
      mat.uom_id = value.uom_id
      mat.price = value.product_cost
      mat.warehouse_no = value.warehouse_no
      var totalCOGS = parseFloat(mat.qty) * parseFloat(mat.price)
      mat.total_cogs = totalCOGS.toString()
    },
    backParent: function () {
      this.$emit('backClicked')
      this.alert = []
    },
    async finishManufacture () {
      this.alert = []
      await this.validateMaterialDuplicate()
      await this.validateAdditionalDuplicate()
      await this.validateMaterialGroup()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data Material tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      await this.recalculateAll()
      await Axios.put(manufactureUrl + '/' + this.manufacture.id, this.dataCollect, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          return false
        })
      var resp = {
        error: false,
        message: null
      }
      await Axios.get(manufactureUrl + '/finish/' + this.manufacture.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          resp = {
            error: false,
            message: response.data.message
          }
        })
        .catch(error => {
          console.log(error.response)
          resp = {
            error: true,
            message: error.response.data.message
          }
          throw Error
        })
      await this.$emit('backClickID', this.manufacture.id)
      await this.$swal('Success', 'Process Kartu Stock', 'success')
      await this.syncInventory('no reply')
      await this.setCOGSAll('no reply')
      await this.setJournal('no reply')
      if (resp.error) {
        this.$swal('Error', resp.message, 'error')
      } else {
        await this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Success', resp.message, 'success')
        await this.$emit('backClickID', this.manufacture.id)
      }
      this.alert = []
    },
    async syncInventory (reply) {
      var resp = {
        error: false,
        message: null
      }
      await Axios.post(manufactureUrl + '/inventory-process', { id: this.manufacture.id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          console.log(response.data.message)
          resp = {
            error: false,
            message: response.data.message
          }
        })
        .catch(error => {
          console.log(error.response)
          resp = {
            error: true,
            message: error.response.data.message
          }
          throw error
        })
      if (reply === 'reply') {
        if (resp.error) {
          await this.$swal('Error', resp.message, 'error')
        } else {
          await this.$swal('Success', resp.message, 'success')
          await this.$emit('backClickID', this.manufacture.id)
        }
      }
    },
    async setCOGSAll (reply) {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.manufacture.mproducts
      var arrMaterial = this.manufacture.materials.filter(d => d.category_id !== 'non-cost')
      console.log(array)
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.manufacture.manufacture_finish_date,
          product_no: array[i].product_no,
          type: 'all',
          company_no: this.manufacture.company_no
        }
        console.log(data)
        var resp = {
          error: false,
          message: null
        }
        // sync cogs mproducts
        await Axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            resp = {
              error: false,
              message: response.data.message
            }
          })
          .catch(error => {
            console.log(error.response)
            resp = {
              error: true,
              message: error.response.data.message
            }
          })
      }
      for (let i = 0; i < arrMaterial.length; i++) {
        var body = {
          date: this.manufacture.manufacture_date,
          product_no: arrMaterial[i].product_no,
          type: 'all',
          company_no: this.manufacture.company_no
        }
        console.log(data)
        // sync cogs materials
        await Axios.post(productUrl + '/cost/sync', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            resp = {
              error: false,
              message: response.data.message
            }
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
          })
      }
      if (reply === 'reply') {
        if (resp.error) {
          await this.$swal('Error', resp.message, 'error')
        } else {
          this.$Progress.finish()
          this.loader.isLoading = false
          await this.$swal('Success', resp.message, 'success')
          await this.$emit('backClickID', this.manufacture.id)
        }
      }
    },
    async setCOGSMaterial (reply) {
      this.$Progress.start()
      this.loader.isLoading = true
      var arrMaterial = this.manufacture.materials.filter(d => d.category_id !== 'non-cost')
      for (let i = 0; i < arrMaterial.length; i++) {
        var body = {
          date: this.manufacture.manufacture_date,
          product_no: arrMaterial[i].product_no,
          type: 'all',
          company_no: this.manufacture.company_no
        }
        var resp = {
          error: false,
          message: null
        }
        // sync cogs materials
        await Axios.post(productUrl + '/cost/sync', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            resp = {
              error: false,
              message: response.data.message
            }
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            // throw error
          })
      }
      if (reply === 'reply') {
        if (resp.error) {
          await this.$swal('Error', resp.message, 'error')
        } else {
          this.$Progress.finish()
          this.loader.isLoading = false
          await this.$swal('Success', resp.message, 'success')
          await this.$emit('backClickID', this.manufacture.id)
        }
      }
    },
    async setCOGS (reply) {
      var array = this.manufacture.mproducts
      console.log(array)
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.manufacture.manufacture_finish_date,
          product_no: array[i].product_no,
          type: 'inventory',
          company_no: this.manufacture.company_no
        }
        console.log(data)
        var resp = {
          error: false,
          message: null
        }
        await Axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            resp = {
              error: false,
              message: response.data.message
            }
          })
          .catch(error => {
            console.log(error.response)
            resp = {
              error: true,
              message: error.response.data.message
            }
          })
      }
      if (reply === 'reply') {
        if (resp.error) {
          await this.$swal('Error', resp.message, 'error')
        } else {
          await this.$swal('Success', resp.message, 'success')
          await this.$emit('backClickID', this.manufacture.id)
        }
      }
    },
    async updateManufacture () {
      if (this.manufacture.counter > 2 && this.authUser.username !== 'root') {
        this.$swal('Error', 'Data telah diupdate lebih dari dua kali', 'error')
      }
      this.$Progress.start()
      this.loader.isLoading = true
      // await this.recalculateAll()
      var mnft = {}
      await Axios.put(manufactureUrl + '/' + this.manufacture.id, this.dataCollect, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          mnft = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          return false
        })
      // Material
      var arrMaterial = this.dataCollectMaterial.filter(d => d.product_no !== null)
      var dataMaterial = []
      for (let i = 0; i < arrMaterial.length; i++) {
        if (typeof arrMaterial[i].id === 'undefined') {
          var ob = {
            manufacture_no: mnft.manufacture_no,
            product_no: arrMaterial[i].product_no,
            qty: arrMaterial[i].qty,
            uom_id: arrMaterial[i].uom_id,
            price: arrMaterial[i].price,
            total_cogs: arrMaterial[i].total_cogs,
            warehouse_no: arrMaterial[i].warehouse_no,
            receive: null,
            received_by: null,
            receive_date: null,
            manufacture_date: mnft.manufacture_date,
            company_no: mnft.company_no,
            branch_no: mnft.branch_no,
            category_id: arrMaterial[i].category_id,
            type_id: mnft.type_id,
            hand_id: arrMaterial[i].hand_id,
            hand_qty: arrMaterial[i].hand_qty,
            hand_uom_id: arrMaterial[i].hand_uom_id,
            mproduct_no: arrMaterial[i].mproduct_no
          }
          dataMaterial.push(ob)
        } else {
          var ob2 = {
            id: arrMaterial[i].id,
            manufacture_no: mnft.manufacture_no,
            product_no: arrMaterial[i].product_no,
            qty: arrMaterial[i].qty,
            uom_id: arrMaterial[i].uom_id,
            price: arrMaterial[i].price,
            total_cogs: arrMaterial[i].total_cogs,
            warehouse_no: arrMaterial[i].warehouse_no,
            receive: null,
            received_by: null,
            receive_date: null,
            manufacture_date: mnft.manufacture_date,
            company_no: mnft.company_no,
            branch_no: mnft.branch_no,
            category_id: arrMaterial[i].category_id,
            type_id: mnft.type_id,
            hand_id: arrMaterial[i].hand_id,
            hand_qty: arrMaterial[i].hand_qty,
            hand_uom_id: arrMaterial[i].hand_uom_id,
            mproduct_no: arrMaterial[i].mproduct_no
          }
          dataMaterial.push(ob2)
        }
      }
      var bodyMaterial = {
        materials: dataMaterial
      }
      console.log('bodyMaterial')
      console.log(bodyMaterial)
      await Axios.post(manufactureUrl + '/material-group', bodyMaterial, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          return false
        })
      // Expense
      var arrExp = this.dataCollectExpense.filter(d => d.amount !== null)
      for (let a = 0; a < arrExp.length; a++) {
        await Axios.post(manufactureUrl + '/expense/', arrExp[a], { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      // await this.$swal.fire({
      //   title: 'Manufacture',
      //   text: 'Update and back to list?',
      //   icon: 'error',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: 'Back'
      // }).then((result) => {
      //   if (result.value) {
      //     this.$emit('backClicked')
      //   } else {
      //     this.$emit('backClickID', this.manufacture.id)
      //   }
      // })
    },
    async validateMaterialGroup () {
      window.scrollTo(0, 0)
      var array = this.groupMaterial
      for (let i = 0; i < array.length; i++) {
        const qtyMaterial = parseFloat(array[i].qty)
        var gpm = this.groupMaterialEdit.find(d => d.product_no === array[i].product_no)
        var qtyExist = gpm ? gpm.qty : '0'
        if (qtyMaterial > 0) {
          var obj = {
            product_no: array[i].product_no,
            date: this.manufacture.manufacture_date
          }
          var url = productUrl + '/cost/get-saldo'
          console.log(obj)
          console.log(url)
          await Axios.post(url, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              const stockQty = parseFloat(response.data.data.qty)
              var qtySaldo = stockQty + parseFloat(qtyExist)
              if (qtySaldo === 0) {
                this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + ' Saldo stock kurang = (' + stockQty + ')')
              } else {
                console.log('Remaining ' + array[i].product_no + ' ' + stockQty + '+ ' + qtyExist + ' = ' + qtySaldo)
                var qtyRemaining = qtySaldo - qtyMaterial
                if (qtyRemaining < 0) {
                  this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + ' Saldo stock kurang = (' + qtySaldo + ')')
                }
              }
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.alert.push(error.response.data.message)
            })
        } else {
          this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + ' Tidak boleh kosong (0)')
        }
      }
    },
    async validateMaterial () {
      window.scrollTo(0, 0)
      this.alert = []
      var array = this.manufacture.materials
      for (let i = 0; i < array.length; i++) {
        const qtyMaterial = parseFloat(array[i].qty)
        var gpm = this.groupMaterialEdit.find(d => d.product_no === array[i].product_no)
        var qtyExist = gpm ? gpm.qty : '0'
        if (qtyMaterial > 0) {
          var obj = {
            product_no: array[i].product_no,
            date: this.manufacture.manufacture_date
          }
          var url = productUrl + '/cost/get-saldo'
          console.log(obj)
          console.log(url)
          await Axios.post(url, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              const stockQty = parseFloat(response.data.data.qty)
              var qtySaldo = stockQty + parseFloat(qtyExist)
              if (qtySaldo === 0) {
                this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + ' Saldo stock kurang = (' + stockQty + ')')
              } else {
                console.log('Remaining ' + array[i].product_no + ' ' + stockQty + '+ ' + qtyExist + ' = ' + qtySaldo)
                var qtyRemaining = qtySaldo - qtyMaterial
                if (array[i].product_no === 'JO-CK') {
                  console.log('JO-CK qtyRemaining: ' + qtySaldo + ' - ' + qtyMaterial)
                }
                if (qtyRemaining < 0) {
                  this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + ' Saldo stock kurang = (' + qtySaldo + ')')
                }
              }
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.alert.push(error.response.data.message)
            })
        } else {
          this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + ' Tidak boleh kosong (0)')
        }
      }
    },
    async createManufacture () {
      this.alert = []
      await this.validateMaterialDuplicate()
      await this.validateAdditionalDuplicate()
      await this.validateMaterialGroup()
      await this.validateNonBiaya()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data Material tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      var mnft = {}
      await Axios.post(manufactureUrl, this.dataCollect, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          mnft = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      // Material
      var arrMaterial = this.dataCollectMaterial.filter(d => d.product_no !== null)
      for (let i = 0; i < arrMaterial.length; i++) {
        var dataMaterial = {
          manufacture_no: mnft.manufacture_no,
          product_no: arrMaterial[i].product_no,
          qty: arrMaterial[i].qty,
          uom_id: arrMaterial[i].uom_id,
          price: arrMaterial[i].price,
          total_cogs: arrMaterial[i].total_cogs,
          warehouse_no: arrMaterial[i].warehouse_no,
          receive: null,
          received_by: null,
          receive_date: null,
          manufacture_date: mnft.manufacture_date,
          company_no: mnft.company_no,
          branch_no: mnft.branch_no,
          category_id: arrMaterial[i].category_id,
          type_id: mnft.type_id,
          mproduct_no: arrMaterial[i].mproduct_no,
          hand_id: arrMaterial[i].hand_id,
          hand_qty: arrMaterial[i].hand_qty,
          hand_uom_id: arrMaterial[i].hand_uom_id
        }
        await Axios.post(manufactureUrl + '/material', dataMaterial, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      // Expense
      // var arrExp = this.dataCollectMaterial.filter(d => d.amount !== null)
      // for (let a = 0; a < arrExp.length; a++) {
      //   await Axios.post(manufactureUrl + '/expense/', arrExp[a], { headers: getHeader() })
      //     .then(response => {
      //     })
      //     .catch(error => {
      //       console.log(error.response)
      //       this.$swal('Error', error.response.data.message, 'error')
      //       return false
      //     })
      // }
      await this.setCOGSMaterial('no reply')
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success Create Manufacture', 'success')
      await this.$emit('backClicked')
    },
    approve () {
      console.log('approve')
    },
    addMaterial (category) {
      var materialLength = this.manufacture.materials.length
      var index = 0
      if (materialLength !== 0) {
        index = materialLength - 1
      }
      var lastIndex = this.manufacture.materials[index]
      var warehouse = this.warehouseList.find(d => d.company_no === this.manufacture.company_no)
      var obj = {
        manufacture_no: null,
        product_no: null,
        product: null,
        qty: '0',
        uom_id: null,
        price: '0',
        total_cogs: '0',
        warehouse_no: warehouse ? warehouse.warehouse_no : null,
        receive: null,
        received_by: null,
        receive_date: null,
        company_no: this.authUser.company_no,
        branch_no: this.authUser.branch_no,
        manufacture_date: this.manufacture.manufacture_date,
        category_id: category,
        type_id: this.manufacture.type_id,
        hand_id: null,
        hand_qty: null,
        hand_uom_id: null,
        mproduct_no: lastIndex.mproduct_no
      }
      this.manufacture.materials.push(obj)
    },
    async removeAllNonCost () {
      var array = this.materialNonCost
      var material = {}
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id === 'undefined') {
          material = this.materialNonCost[i]
        }
        var idx = this.manufacture.materials.indexOf(material)
        if (typeof material.id === 'undefined') {
          this.manufacture.materials.splice(idx, 1)
        } else {
          await Axios.delete(manufactureUrl + '/material/' + material.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              this.manufacture.materials.splice(idx, 1)
            })
            .catch(error => {
              console.log(error.response)
            })
        }
      }
    },
    async removeMaterial (index, category) {
      var material = {}
      if (category === 'order') {
        material = this.materialOrder[index]
      } else if (category === 'additional') {
        material = this.materialAdditional[index]
      } else if (category === 'non-cost') {
        material = this.materialNonCost[index]
      }
      var idx = this.manufacture.materials.indexOf(material)
      if (typeof material.id === 'undefined') {
        this.manufacture.materials.splice(idx, 1)
        this.calcMProduct()
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(manufactureUrl + '/material/' + material.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.manufacture.materials.splice(idx, 1)
                this.calcMProduct()
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
        if (category !== 'non-cost') {
          var data = {
            date: this.manufacture.manufacture_finish_date,
            product_no: material.product_no,
            type: 'all',
            company_no: null
          }
          // sync cogs mproducts
          await Axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
            })
        }
        await this.$emit('backClickID', this.manufacture.id)
      }
    },
    async print () {
      var url = null
      var type = this.manufacture.type_id
      if (type === 'fdaa4c3dc0ab41c587c47b62d407cba8') {
        url = '/print'
      } else if (type === 'a384a995aa854c1399d960b9b5198d9b') {
        url = '/print'
      } else if (type === 'c2d5d91d269e4f7c8c4853339b3d55a9') {
        url = '/print2'
      }

      var data = {
        manufacture: this.manufacture
      }
      await Axios.post(manufacture2Url + url, data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
        })
        .catch(error => {
          console.log(error.response)
        })
    }
  },
  mounted () {
    this._keyListener = function (e) {
      if (e.key === 'enter' && (e.ctrlKey || e.metaKey)) {
        e.preventDefault()
        this.addMaterial('order')
      }
    }

    document.addEventListener('keydown', this._keyListener.bind(this))
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this._keyListener)
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
